import type { FilterDefinition, FilterHandler } from '../engine/types';
import {
  FilterId,
  FilterType,
  type MultiFilter,
  type RangeFilter,
  type SegmentedFilter,
} from '../types/filters';

export const multiHiringRateDefinition: FilterDefinition<
  MultiFilter<SegmentedFilter<RangeFilter>>
> = {
  id: FilterId.MULTI_HIRING_RATE,
  name: 'Hiring Rate',
  type: FilterType.MULTI,
  wrappedFilterId: FilterId.HIRING_RATE,
  instances: [],
  isVisible: true,
};

export const multiHiringRateHandler: FilterHandler<
  MultiFilter<SegmentedFilter<RangeFilter>>
> = {
  isActive(currentFilterState) {
    return currentFilterState.instances.length > 0;
  },
  isDefault(currentFilterState) {
    return currentFilterState.instances.length === 0;
  },
  getEffectiveFilter(currentFilterState) {
    return currentFilterState;
  },
};
